module.exports = __webpack_public_path__ + "fontawesome-webfont.d95d6f5d5ab7cfefd096.woff";


//////////////////
// WEBPACK FOOTER
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/assets/font-awesome/fonts/fontawesome-webfont.woff?v=4.2.0
// module id = ../../../../../src/assets/font-awesome/fonts/fontawesome-webfont.woff?v=4.2.0
// module chunks = 2